import {
  DTOCreateForgeProjectIteration,
  DTOCreateForgeProjectIterationResponse,
  DTODeleteForgeProjectIterationResponse,
  DTOUpdateForgeProjectIteration,
  DTOUpdateForgeProjectIterationResponse,
} from "../../dto";
import { RequestExecutor } from "../../transport";

export class ForgeProjectIterationsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(workspaceId: string, projectId: string) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/iterations`,
      DTOUpdateForgeProjectIterationResponse,
      {
        method: "GET",
      }
    );
  }

  create(workspaceId: string, projectId: string, body: DTOCreateForgeProjectIteration) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/iterations`,
      DTOCreateForgeProjectIterationResponse,
      {
        method: "POST",
        body,
      }
    );
  }

  update(workspaceId: string, projectId: string, id: string, body: DTOUpdateForgeProjectIteration) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/iterations/${id}`,
      DTOCreateForgeProjectIterationResponse,
      {
        method: "PUT",
        body,
      }
    );
  }

  merge(workspaceId: string, projectId: string, id: string) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/iterations/${id}/merge`,
      DTOCreateForgeProjectIterationResponse,
      {
        method: "POST",
        body: {},
      }
    );
  }

  delete(workspaceId: string, projectId: string, id: string) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/iterations/${id}`,
      DTODeleteForgeProjectIterationResponse,
      {
        method: "DELETE",
      }
    );
  }
}
